import { render, staticRenderFns } from "./logisticsInfo.vue?vue&type=template&id=63742094&scoped=true"
import script from "./logisticsInfo.vue?vue&type=script&lang=js"
export * from "./logisticsInfo.vue?vue&type=script&lang=js"
import style0 from "./logisticsInfo.vue?vue&type=style&index=0&id=63742094&prod&lang=scss&scoped=true"
import style1 from "./logisticsInfo.vue?vue&type=style&index=1&id=63742094&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63742094",
  null
  
)

export default component.exports